<template>
  <l-layout :layout="['xs12']">
    <v-card>
      <v-card-title class="py-0 my-0" style="height: 80px">
        <div class="pl-2">
          <span class="grey--text title px-2" v-if="!reservation.name && authority.editGroupInfo">{{reservation.name}}</span>
          <span class="title px-2" v-else-if="reservation.name">{{reservation.name}}</span>
          <span class="title px-2" v-else>{{authority.name}}</span>
          <span class="grey--text">正在编辑</span>
        </div>
      </v-card-title>
      <v-card-text>
        <v-container class="pt-0" fluid grid-list-md>
          <v-layout v-if="authority.editGroupInfo||type==='org'" wrap>
            <v-flex sm6 xs12>
              <v-text-field
                label="预约名称"
                prepend-icon="$vuetify.icons.title"
                v-model="reservation.name"
                :disabled="status==='addVehicle'"
              ></v-text-field>
            </v-flex>
            <v-flex sm6 xs12>
              <v-textarea
                :rows="1"
                auto-grow
                label="预约描述"
                prepend-icon="$vuetify.icons.description"
                v-model="reservation.description"
                :disabled="status==='addVehicle'"
              ></v-textarea>
            </v-flex>
          </v-layout>
          <v-layout v-if="type==='person'">
            <v-flex xs6>
              <v-text-field prepend-icon="$vuetify.icons.comment" label="预约备注" v-model="reservationTips" :disabled="status==='addVehicle'"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout column v-if="type!=='org'">
            <!-- <v-switch
              :disabled="status==='addVehicle'"
              v-model="isSelf"
              label="开启自助预约"></v-switch> -->
            <v-card v-if="isSelf" class="pa-3 mb-3">
              <v-subheader>预约二维码配置</v-subheader>
              <v-layout column>
                <v-layout>
                  <v-flex xs6>
                    <v-text-field label="自助预约总数" v-model="selfInfo.total" prepend-icon="$vuetify.icons.code"
                                  :rules="[$rules.requiredNum()]"></v-text-field>
                  </v-flex>
                <!--  <v-flex xs3>
                    <v-radio-group mandatory row v-model="selfInfo.isLock">
                      <v-radio :value="'1'" label="是"></v-radio>
                      <v-radio :value="'0'" label="否"></v-radio>
                    </v-radio-group>
                  </v-flex>-->
                </v-layout>
                <v-layout>
                  <v-flex xs6>
                    <l-select-datetime label="二维码开始时间" v-model="selfInfo.stTime"></l-select-datetime>
                  </v-flex>
                  <v-flex xs6>
                    <l-select-datetime label="二维码结束时间" v-model="selfInfo.edTime"></l-select-datetime>
                  </v-flex>
                </v-layout>
              </v-layout>
             <!-- <v-layout>
                <v-flex xs6>
                  <v-text-field label="用户可选择时间片数量" v-model="selfInfo.sectionLimit" prepend-icon="$vuetify.icons.code"
                                :rules="[$rules.requiredNum()]"></v-text-field>
                </v-flex>
                <v-flex xs4 >
                  <v-btn flat color="primary" @click="addTimeSection">添加时间片</v-btn>
                </v-flex>
              </v-layout>
              <v-card v-for="(t,i) in selfInfo.timeSections" class="pa-3 mb-2">
                <v-layout column>
                  <v-layout>
                    <v-flex xs6>
                      <l-select-datetime label="开始时间" v-model="t.stTime"></l-select-datetime>
                    </v-flex>
                    <v-flex xs6>
                      <l-select-datetime label="结束时间" v-model="t.edTime"></l-select-datetime>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-text-field label="该时间片可预约次数" v-model="t.limit" prepend-icon="$vuetify.icons.code"
                                  :rules="[$rules.requiredNum()]"></v-text-field>
                  </v-layout>
                  <v-layout>
                    <v-btn flat color="primary" :disabled="t.passRule.length===1" @click=" selfInfo.sectionPassRuleDialog = {
                          activate: true,
                          status: 'new',
                          item: null || undefined,
                          index: 0,
                          curIndex:i
                        }">添加规则</v-btn>
                  </v-layout>
                  <v-layout>
                    <v-flex xs12>
                      <l-pass-rule-list
                        :pass-rules="t.passRule"
                        prefix-text="规则"
                      >
                        <template slot="action" slot-scope="{item, index}">
                          <div @click.stop>
                            <v-menu left>
                              <v-btn icon slot="activator" small>
                                <v-icon small>$vuetify.icons.more</v-icon>
                              </v-btn>
                              <v-list dense>
                                <v-list-tile
                                  @click=" selfInfo.sectionPassRuleDialog = {
                                  activate: true,
                                  status: 'edit',
                                  item: t.passRule[0],
                                  index: 0,
                                  curIndex:i
                                  }">
                                  <v-list-tile-title class="pr-1">
                                    <v-icon class="pr-3" small>$vuetify.icons.edit</v-icon>
                                    编辑
                                  </v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile @click="deleteSelfSectionRuleLocal(item, t.passRule)">
                                  <v-list-tile-title class="pr-1">
                                    <v-icon class="pr-3" small>$vuetify.icons.delete</v-icon>
                                    删除
                                  </v-list-tile-title>
                                </v-list-tile>
                              </v-list>
                            </v-menu>
                          </div>
                        </template>
                      </l-pass-rule-list>
                    </v-flex>
                  </v-layout>
                </v-layout>
              </v-card>-->
            </v-card>
          </v-layout>
          <v-card class="pl-3">
          <v-subheader>预约行人
          </v-subheader>
          <v-layout class="mb-4" row wrap>
            <v-flex xs12>
              <l-data-table
                :headers="vehicleHeaders"
                :hide-headers="reservation.vehicles.length === 0"
                :init-pagination="{sortBy: 'id', descending: true}"
                :items="vehicleList"
                auto-actions
                auto-title
                class=""
                flat
                hide-refresh
                no-data-text="没有行人"
                selectable
                v-model="selected"
              ></l-data-table>
            </v-flex>
            <v-flex xs12>
              <!--<v-slide-y-transition  group>-->
              <div :key="'addForm'" v-show="isAddingVehicle">
                <v-container class="pa-0" grid-list-md>
                  <v-form ref="addVehicleForm">
                    <v-layout key="addInput" row wrap>
                      <v-flex sm6 xs12 >
                        <v-text-field
                          label="访客姓名"
                          prepend-icon="$vuetify.icons.person"
                          v-model="addVehicleForm.ownerName"
                          :rules="(type==='admin')?[]:[$rules.requiredS()]"
                          validate-on-blur
                        ></v-text-field>
                      </v-flex>
                      <!--<v-flex sm6 xs12>-->
                      <!--  <v-text-field-->
                      <!--    label="单位|车牌"-->
                      <!--    prepend-icon="$vuetify.icons.group"-->
                      <!--    v-model="addVehicleForm.ownerOrg"-->
                      <!--    hint="用户可以填写xx单位-xx车"-->
                      <!--    validate-on-blur-->
                      <!--  ></v-text-field>-->
                      <!--</v-flex>-->
                      <v-flex sm6 xs12>
                        <v-text-field
                          label="访客手机"
                          prepend-icon="$vuetify.icons.phone"
                          v-model="addVehicleForm.ownerTel"
                          :rules="$rules.phone11()"
                          validate-on-blur
                        ></v-text-field>
                      </v-flex>
                      <v-flex sm6 xs12>
                        <v-text-field
                          label="证件号码"
                          prepend-icon="$vuetify.icons.idCard"
                          v-model="addVehicleForm.ownerIDNumber"
                          :rules="[$rules.idNumber()]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-btn @click="addVehicle()" color="primary" flat>添加</v-btn>
                        <v-btn @click="addVehicle(0)" color="grey" flat>取消</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-container>
              </div>
              <v-flex key="btnGroup" v-show="!isAddingVehicle">
                <v-btn
                  :disabled="reservation.vehicles.length >= authority.maxVehicleAmount"
                  @click="openAddVehicleForm"
                  class="mx-0"
                  color="primary"
                  flat
                >添加行人
                </v-btn>
                <l-select-file
                  :dialog-props="vehicleFileProps"
                  :hint="'仅支持Excel(.xlsx)文件'"
                  :rules="vehicleFileRules"
                  @cancel="vehicleFileProps.activate = false"
                  @submit="readExcel"
                  file-type="excel"
                  select-type="dialog"
                  v-if="authority.maxVehicleAmount > 1"
                >
                  <v-btn class="mx-0" color="primary" flat
                         slot="activator">批量导入
                  </v-btn>
                  <template slot="before-drag">
                    <v-layout align-center class="mb-3 pl-2" row>
                      <span class="body-2">批量导入行人需要上传特定格式的模板</span>
                      <v-btn
                        :href="templateHref"
                        @click="getVehicleFileTemplate"
                        color="primary"
                        flat
                        ref="templateBtn"
                        small
                        target="_blank"
                      >点此下载
                      </v-btn>
                    </v-layout>
                  </template>
                </l-select-file>
                <v-fade-transition>
                  <v-btn
                    @click="deleteVehicles(selected)"
                    class="mx-0"
                    color="error"
                    flat
                    v-if="selected.length > 0"
                  >删除选中行人
                  </v-btn>
                </v-fade-transition>
              </v-flex>
              <!--</v-slide-y-transition>-->
            </v-flex>
          </v-layout>
          </v-card>
          <v-card class="pl-3">
          <v-subheader v-if="status!=='addVehicle'">通行规则</v-subheader>
          <v-layout class="mb-4" row wrap v-if="status!=='addVehicle'">
            <v-flex xs12>
              <l-pass-rule-list
                :pass-rules="reservation.rules"
                prefix-text="规则"
                :show-flag="false"
              >
                <template slot="action" slot-scope="{item, index}">
                  <div @click.stop>
                    <v-menu left>
                      <v-btn icon slot="activator" small>
                        <v-icon small>$vuetify.icons.more</v-icon>
                      </v-btn>
                      <v-list dense>
                        <v-list-tile
                          @click="openSetRuleDialog('edit',reservation.rules[index], index)">
                          <v-list-tile-title class="pr-1">
                            <v-icon class="pr-3" small>$vuetify.icons.edit</v-icon>
                            编辑
                          </v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click="deleteRuleLocal(item, reservation.rules)">
                          <v-list-tile-title class="pr-1">
                            <v-icon class="pr-3" small>$vuetify.icons.delete</v-icon>
                            删除
                          </v-list-tile-title>
                        </v-list-tile>
                      </v-list>
                    </v-menu>
                  </div>
                </template>
              </l-pass-rule-list>
            </v-flex>
            <v-flex xs12>
              <v-btn
                @click="openSetRuleDialog('new', null, reservation.rules.length)"
                class="mr-0 mx-1"
                color="primary" flat>添加规则
              </v-btn>
            </v-flex>
          </v-layout>
          </v-card>
          <v-card class="pl-3">
         <!-- <v-subheader v-if="authority.editPrompt&&status!=='addVehicle'" >通行提示</v-subheader>
          <v-layout class="mb-4" v-if="authority.editPrompt&&status!=='addVehicle'" wrap >
            <v-flex :class="opt.layout" :key="opt.key" v-for="opt in promptDefine">
              <v-textarea
                :prepend-icon="opt.icon"
                :rows="1"
                auto-grow=""
                v-bind="opt"
                v-model="reservation[opt.key]"
              ></v-textarea>
            </v-flex>
          </v-layout>-->
          <person-info-card :person="reservation.owner" flat subheader="联系人" v-show="type!=='person'">
            <template slot="subheader-action">
              <v-btn
                @click="configDialog = {activate: true, item: {}, status: 'new', params: {}}"
                class="mx-0"
                color="primary"
                flat
                small
              >{{reservation.owner ? '变更受访人':'添加受访人'}}
              </v-btn>
            </template>
          </person-info-card>
          <person-info-card :person="reservation.applicant" flat subheader="申请人" v-show="type!=='person'"></person-info-card>
          </v-card>
        </v-container>
        <v-dialog max-width="500px" persistent scrollable v-model="configDialog.activate">
          <select-be-visit-dialog
            :params="configDialog.params"
            :raw-item="configDialog.item"
            :status="configDialog.status"
            :type="type"
            @cancel="configDialog.activate = false"
            @confirm="saveBeVisited"
            object-label="分组名称"
            v-if="configDialog.activate"
          ></select-be-visit-dialog>
        </v-dialog>
        <v-dialog max-width="900px" persistent scrollable v-model="passRuleDialog.activate">
          <set-pass-rule-content
            :authority="authority"
            :pass-type="'person'"
            :params="{index: passRuleDialog.index, type: authority.name}"
            :rule="passRuleDialog.item"
            :status="passRuleDialog.status"
            @cancel="closeSetRuleDialog"
            @save="setPassRuleLocal($event, reservation.rules)"
            v-if="passRuleDialog.activate"
          ></set-pass-rule-content>
        </v-dialog>
        <v-dialog max-width="900px" persistent scrollable v-model="selfInfo.passRuleDialog.activate">
          <set-pass-rule-content
            :authority="authority"
            :pass-type="'person'"
            :params="{index: selfInfo.passRuleDialog.index, type: authority.name}"
            :rule="selfInfo.passRuleDialog.item"
            :status="selfInfo.passRuleDialog.status"
            @cancel="closeSelfSetRuleDialog"
            @save="setSelfPassRuleLocal($event, selfInfo.passRule)"
            v-if="selfInfo.passRuleDialog.activate"
          ></set-pass-rule-content>
        </v-dialog>
        <v-dialog max-width="900px" persistent scrollable v-model="selfInfo.sectionPassRuleDialog.activate">
          <set-pass-rule-content
            :authority="authority"
            :pass-type="'person'"
            :params="{index: selfInfo.sectionPassRuleDialog.index, type: authority.name}"
            :rule="selfInfo.sectionPassRuleDialog.item"
            :status="selfInfo.sectionPassRuleDialog.status"
            @cancel="closeSelfSectionSetRuleDialog"
            @save="setSelfSectionPassRuleLocal($event, selfInfo.timeSections[selfInfo.sectionPassRuleDialog.curIndex].passRule)"
            v-if="selfInfo.sectionPassRuleDialog.activate"
          ></set-pass-rule-content>
        </v-dialog>
        <v-dialog max-width="1000px" persistent scrollable v-model="importErrorDialog.activate">
          <v-card>
            <v-card-title style="height: 64px;">
              <span class="title">导入行人发生错误</span>
            </v-card-title>
            <v-card-text style="min-height: 350px; max-height: 500px">
              <div class="mb-4" v-if="importErrorDialog.fails.length > 0">
                <div class="subheading py-2">以下行人信息格式错误</div>
                <!--<v-divider></v-divider>-->
                <l-data-table
                  :headers="errorHeader"
                  :init-pagination="{rowsPerPage: 5 ,sortBy: 'id', descending: false}"
                  :items="importErrorDialog.fails"
                  auto-actions
                  flat
                  hide-title
                ></l-data-table>
              </div>
              <div class="mb-4" v-if="importErrorDialog.duplicates.length > 0">
                <div class="subheading py-2">以下行人已在行人列表中</div>
                <!--<v-divider></v-divider>-->
                <l-data-table
                  :headers="vehicleHeaders"
                  :init-pagination="{rowsPerPage: 5 ,sortBy: 'id', descending: false}"
                  :items="importErrorDialog.duplicates"
                  auto-actions
                  flat
                  hide-title
                ></l-data-table>
              </div>
              <div v-if="importErrorDialog.vehicles.length > 0">
                <div class="py-2">
                  <div class="subheading">以下行人信息正确，等待导入</div>
                  <div class="py-1" v-if="importErrorDialog.haveDuplicatePlate">
                    <span class="error--text caption">您导入的模板中含有重复的行人，导入时将以重复数据的第一条为准</span>
                  </div>
                </div>
                <!--<v-divider></v-divider>-->
                <l-data-table
                  :headers="vehicleHeaders"
                  :init-pagination="{rowsPerPage: 5 ,sortBy: 'id', descending: false}"
                  :items="importErrorDialog.vehicles"
                  auto-actions
                  flat
                  hide-title
                ></l-data-table>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="importVehicle(0)" color="grey" flat large>取消导入</v-btn>
              <v-btn :disabled="importErrorDialog.vehicles.length === 0"
                     @click="importVehicle(importErrorDialog.vehicles)"
                     color="error" flat large>仍然导入
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card-text>
    </v-card>
    <v-flex class="text-xs-right pt-2">
      <v-btn :loading="submitLoading" @click="submit" class="mx-0" color="primary">提交</v-btn>
    </v-flex>
    <v-dialog v-model="confirmDialog.activated" width="600" persistent scrollable>
      <v-card>
        <v-card-title class="pa-0" style="display: flex; justify-content: center; align-content: center; height: 56px">
          <h3>{{ confirmDialog.title }}</h3>
        </v-card-title>
        <v-card-text class="text--primary">
          <div
            style="white-space: pre-wrap"
            v-text="confirmDialog.msg"
          />
          <div class="text-center" style="display: flex;justify-content: center">
            <v-btn
              color="primary"
              style="display: inline-block"
              @click="confirmDialog.activated = false"
            >同意
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </l-layout>
</template>

<script>
import XLSX from 'xlsx'
import LPlatePicker from '../../../components/LPlatePicker'
import LPassRuleList from '../../../components/LPassRuleList'
import SelectBeVisitDialog from './selectBeVisitDialog'
import PersonInfoCard from '../../../components/personInfoCard'
import SetPassRuleContent from '../../../components/SetPassRuleContent'
import {Reservation, ReservationAuthority} from '../../../object'
import {ID_TYPE_TEXT, ID_TYPE_REVERSE} from '../../../consts/reservation'
import {passRule} from '@/mixins'
import LSelectDatetime from '../../../ladmin/components/LSelectDatetime/LSelectDatetime'
import {PassRule} from '../../../object'
import {time} from '../../../ladmin/utils/time'
import {msg, title} from '../../../utils/notice'

function VisitorVehicle (id = 0, p = '', t = '', n = '', o = '', idt = '', idn = '') {
  return {
    id: id,
    plate: p,
    ownerTel: t,
    ownerName: n,
    ownerOrg: o,
    ownerIDNumber: idn,
    ownerIDType: idt,
  }
}
let errorMap = {
  '1': '电话格式有误',
  '2': '存在必填数据为空',
  '3': '身份证格式错误',
  '4': '电话号码存在重复',
  '5': '身份证号码存在重复'
}
export default {
  name: 'PersonReservationForm',
  components: {LSelectDatetime, SetPassRuleContent, PersonInfoCard, SelectBeVisitDialog, LPassRuleList, LPlatePicker},
  mixins: [passRule],
  props: {
    reservation: {
      type: Object,
      required: true,
    },
    authority: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    status: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      reservationTips: '',
      isSelf: false,
      confirmDialog: {
        activated: false,
        msg: '',
        title: ''
      },
      selfInfo: {
        passRuleDialog: {
          activate: false,
          status: 'new',
          item: {},
          index: 0,
        },
        sectionPassRuleDialog: {
          activate: false,
          status: 'new',
          item: {},
          index: 0,
          curIndex: 0
        },
        sectionConfig: false,
        total: '',
        stTime: '',
        edTime: '',
        passRule: [],
        sectionLimit: 1,
        timeSections: [],
        isLock: '1'
      },
      promptDefine: [
        {
          placeholder: '',
          disabled: false,
          key: 'ledPromptIn',
          label: '进场屏显提示',
          layout: ['xs12'],
          textarea: true,
          icon: '$vuetify.icons.led',
        },
        {
          placeholder: '',
          disabled: false,
          key: 'audioPromptIn',
          label: '进场语音提示',
          layout: ['xs12'],
          textarea: true,
          icon: '$vuetify.icons.audio',
        },
        {
          placeholder: '',
          disabled: false,
          key: 'ledPromptOut',
          label: '出场屏显提示',
          layout: ['xs12'],
          textarea: true,
          icon: '$vuetify.icons.led',
        },
        {
          placeholder: '',
          disabled: false,
          key: 'audioPromptOut',
          label: '出场语音提示',
          layout: ['xs12'],
          textarea: true,
          icon: '$vuetify.icons.audio',
        },
      ],
      vehicleHeaders: [
        {text: '通行对象', value: 'plate', align: 'left'},
        {text: '姓名', value: 'ownerName', align: 'left'},
        {text: '手机号码', value: 'ownerTel', align: 'left'},
        {text: '证件号码', value: 'ownerIDNumber', align: 'left'},
        // {text: '单位|车牌', value: 'ownerOrg', align: 'left'},
      ],
      errorHeader: [
        {text: '通行对象', value: 'plate', align: 'left'},
        {text: '姓名', value: 'ownerName', align: 'left'},
        {text: '手机号码', value: 'ownerTel', align: 'left'},
        {text: '证件号码', value: 'ownerIDNumber', align: 'left'},
        // {text: '单位|车牌', value: 'ownerOrg', align: 'left'},
        {text: 'error', value: 'error', align: 'right', placeholder: 'N/A'},
      ],
      vehicleList: [],
      IDTypeReverseMap: ID_TYPE_REVERSE,
      IDTypeMap: ID_TYPE_TEXT,
      IDTypeItems: Object.keys(ID_TYPE_TEXT).map(key => ({text: ID_TYPE_TEXT[key], value: key})),
      beVisited: null,
      configDialog: {
        activate: false,
        item: {},
        loading: false,
        status: 'new',
        params: {},
      },
      templateHref: '',
      errorStatus: false,
      pageErrorMessage: '',
      vehicleFileProps: {
        activate: true,
        autoClose: true,
        title: '批量导入行人',
      },
      vehicleFileRules: [
        v => !(!v || v.length === 0) || '必选',
        v => !v.some(f => !/\.xlsx$/i.test(f.name)) || '仅支持Excel表格(.xlsx)格式',
      ],
      submitLoading: false,
      isAddingVehicle: false,
      selected: [],
      showAllPagination: {
        page: 1,
        rowsPerPage: 1000,
        sortBy: 'id',
      },
      importErrorDialog: {
        activate: false,
        vehicles: [],
        fails: [],
        duplicates: [],
        haveDuplicatePlate: false,
      },
      addVehicleForm: {
        plate: '',
        ownerTel: '',
        ownerName: '',
        ownerOrg: '',
        ownerIDNumber: '',
        ownerIDType: '',
      },
      offsetTop: 0,
      mounted: 0,
      // passRuleDialog: {
      //   activate: false,
      //   status: 'new',
      //   item: {},
      //   index: 0,
      // },
    }
  },
  computed: {
    dark () {
      return this.$vuetify.dark
    },
    self () {
      return this.$store.state.login.self
    },
    isNew () {
      return true
    },
    isPersonal () {
      return this.$route.name === 'PersonNewPersonalReservation'
    }
  },
  mounted () {
    this.getReservationConfig()
  },
  methods: {
    openAddVehicleForm () {
      this.isAddingVehicle = true
      // 临时提前验证，和通行关口统一
      this.$nextTick(() => {
        this.$refs.addVehicleForm.validate()
      })
    },
    saveBeVisited ({newItem, oldItem}) {
      this.reservation.owner = newItem
      this.configDialog.activate = false
    },
    async getVehicleFileTemplate () {
      try {
        let url = await this.$store.dispatch('personReservation/getVehicleFileTemplate')
        let isSupportDownload = 'download' in document.createElement('a')
        console.log('get url', url, isSupportDownload)
        let el = document.createElement('a')
        el.href = url
        el.target = '_blank'
        el.download = '预约人行批量导入模板'
        el.style.display = 'none'
        document.body.appendChild(el)
        el.click()
        document.body.removeChild(el)
      }
      catch (e) {
        this.$L.alert('error', {title: '获取模板时发生错误', message: e.message, raw: e})
      }
    },
    resetImportDialog () {
      this.importErrorDialog = {
        activate: false,
        vehicles: [],
        fails: [],
        duplicates: [],
        haveDuplicatePlate: false,
      }
    },
    importVehicle (vehicles) {
      if (vehicles) {
        this.reservation.vehicles.push(...vehicles)
        this.vehicleList.push(...vehicles)
        this.$L.alert('success', {message: `成功导入${vehicles.length}项`})
      }
      this.resetImportDialog()
    },
    checkVehicle (v, vehicles) {
      if (!this.$reg.PHONE_ALL.test(v.ownerTel.trim())) {
        return 1
      }
      else if (v.ownerIDNumber.trim() && !this.$reg.idCard.test(v.ownerIDNumber.trim())) {
        return 3
      }
      else if (this.hasEmpty(v)) {
        return 2
      }
      else if (this.hasSamePhone(v, vehicles)) {
        return 4
      }
      else if (this.hasSameIdNumber(v, vehicles)) {
        return 5
      }
      return 0
    },
    hasSamePhone (v, vehicles) {
      let arr = this.reservation.vehicles.filter(t => t.ownerTel === v.ownerTel)
      let arr2 = vehicles.filter(t => t.ownerTel === v.ownerTel)
      // console.log(arr2)
      return !((arr.length === 0 && arr2.length === 0))
    },
    hasSameIdNumber (v, vehicles) {
      let arr = this.reservation.vehicles.filter(t => t.ownerIDNumber && t.ownerIDNumber === v.ownerIDNumber)
      let arr2 = vehicles.filter(t => t.ownerIDNumber && t.ownerIDNumber === v.ownerIDNumber)
      console.log(arr2)
      return !((arr.length === 0 && arr2.length === 0))
    },
    hasEmpty (v) {
      // console.log(v)
      return v.ownerTel === '' || ((this.type === 'admin') ? false : v.ownerName === '')
    },
    readExcel (files) {
      let f = files[0]
      if (!(f instanceof File)) return
      let reader = new FileReader()
      reader.onload = (event) => {
        try {
          let data = event.target.result
          let workbook = XLSX.read(data, {type: 'array'})
          let keys = Object.keys(workbook.Sheets)
          if (Object.keys(workbook.Sheets).length < 1) {
            throw Error('模板格式错误')
          }
          let sheet = workbook.Sheets[keys[0]]
          let ref = sheet['!ref']
          let group = /^[A-Z]+(\d+):[A-Z]+(\d+)$/.exec(ref)
          if (!group) {
            throw Error('模板格式错误')
          }
          let s = Number(group[1])
          let e = Number(group[2])

          if (e > this.authority.maxVehicleAmount + 1) {
            this.$L.alert('error', {
              title: '导入模板时发生错误',
              message: `给定文件条目超过最大单次预约行人数，单次最多添加 ${this.authority.maxVehicleAmount} 个行人`,
            })
            return
          }

          let atters = ['A', 'B', 'C', 'D', 'E', 'F']
          let vehicles = []
          let fails = []
          let duplicates = []
          let haveDuplicatePlate = false

          for (let i = s + 1; i <= e; ++i) {
            let plate = sheet[atters[0] + i] ? sheet[atters[0] + i].w.trim() : ''
            let phone = sheet[atters[0] + i] ? sheet[atters[0] + i].w : ''
            let IDNumber = sheet[atters[2] + i] ? sheet[atters[2] + i].w.trim() : ''
            let name = sheet[atters[1] + i] ? sheet[atters[1] + i].w : ''
            // let org = sheet[atters[2] + i] ? sheet[atters[2] + i].w : ''
            if (plate == '' && phone == '' && IDNumber == '' && name == '') {
              continue
            }
            let v = new VisitorVehicle(
              this.reservation.vehicles.length + vehicles.length,
              plate,
              phone,
              name,
              // org,
              '',
              IDNumber ? 'idCard' : '',
              IDNumber,
            )
            let checkRes = this.checkVehicle(v, vehicles)
            if (checkRes === 0) {
              if (this.reservation.vehicles.find(t => (t.ownerTel === v.ownerTel) && (t.ownerIDNumber === v.ownerIDNumber))) {
                duplicates.push(v)
              }
              else {
                let tmp = vehicles.find(t => (t.ownerTel === v.ownerTel) && (t.ownerIDNumber === v.ownerIDNumber))
                if (tmp) {
                  // console.log('find duplicate', tmp, v)
                  haveDuplicatePlate = true
                }
                else {
                  vehicles.push(v)
                  plate = IDNumber
                  if (plate) {
                    let newV = new VisitorVehicle(
                      this.reservation.vehicles.length + vehicles.length,
                      plate,
                      phone,
                      name,
                      // org,
                      '',
                      IDNumber ? 'idCard' : '',
                      IDNumber,
                    )
                    vehicles.push(newV)
                  }
                }
              }
            }
            else {
              v.error = errorMap[checkRes]
              fails.push(v)
            }
          }
          console.log('check import', fails, duplicates, vehicles)
          if (fails.length === 0 && duplicates.length === 0 && !haveDuplicatePlate) {
            this.importVehicle(vehicles)
          }
          else {
            this.importErrorDialog = {
              activate: true,
              vehicles: vehicles,
              fails: fails,
              duplicates: duplicates,
              haveDuplicatePlate: haveDuplicatePlate,
            }
          }
        }
        catch (e) {
          this.$L.alert({title: '读取导入模板时发生错误', message: '给定的文件格式错误，或浏览器版本不支持'})
        }
      }
      reader.readAsArrayBuffer(f)
    },
    closeSelfSetRuleDialog () {
      this.selfInfo.passRuleDialog = {
        activate: false,
        status: 'new',
        item: undefined,
        index: 0,
      }
    },
    closeSelfSectionSetRuleDialog () {
      this.selfInfo.sectionPassRuleDialog = {
        activate: false,
        status: 'new',
        item: undefined,
        index: 0,
      }
    },
    async setSelfPassRuleLocal ({newItem, oldItem, status}, array) {
      if (!newItem) {
        this.selfInfo.passRuleDialog.activate = false
        return
      }
      if (status === 'new' && newItem) {
        array.push(newItem)
      }
      if (status === 'edit' && newItem) {
        let i = array.indexOf(oldItem)
        if (i !== -1) {
          array.splice(i, 1, newItem)
        }
      }
      this.closeSelfSetRuleDialog()
    },
    async setSelfSectionPassRuleLocal ({newItem, oldItem, status}, array) {
      if (!newItem) {
        this.selfInfo.sectionPassRuleDialog.activate = false
        return
      }
      if (status === 'new' && newItem) {
        array.push(newItem)
      }
      if (status === 'edit' && newItem) {
        let i = array.indexOf(oldItem)
        if (i !== -1) {
          array.splice(i, 1, newItem)
        }
      }
      this.closeSelfSectionSetRuleDialog()
    },
    async deleteSelfRuleLocal (r, array) {
      if (r) {
        let {res, close} = await this.$L.confirm({
          title: '确认删除',
          text: '确认删除此规则？',
        })
        if (res) {
          let i = array.indexOf(r)
          // console.log(r, i)
          if (i !== -1) {
            array.splice(i, 1)
          }
        }
        close()
      }
    },
    async deleteSelfSectionRuleLocal (r, array) {
      if (r) {
        let {res, close} = await this.$L.confirm({
          title: '确认删除',
          text: '确认删除此规则？',
        })
        if (res) {
          let i = array.indexOf(r)
          // console.log(r, i)
          if (i !== -1) {
            array.splice(i, 1)
          }
        }
        close()
      }
    },
    addTimeSection () {
      this.selfInfo.timeSections.push({
        stTime: '',
        edTime: '',
        limit: 1,
        passRule: []
      })
    },
    async submit () {
      // console.log(this.reservation)
      if (this.isAddingVehicle) {
        if (this.$refs.addVehicleForm.validate()) {
          this.addVehicle()
        }
        else {
          return
        }
      }
      if (this.reservation.vehicles.length < 1 && !this.isSelf) {
        this.$L.alert('error', {title: '未选择预约行人', message: '请填写预约行人信息'})
        return
      }
      else if (this.reservation.rules.length < 1 && this.status !== 'addVehicle' && !this.isSelf) {
        this.$L.alert('error', {title: '未选择通行规则', message: '请填写通行规则信息'})
        return
      }
      else if (!this.reservation.applicant && this.status !== 'addVehicle') {
        this.$L.alert('error', {title: '未选择受访人', message: '请添加受访人'})
        return
      }
      this.submitLoading = true
      console.log(this.reservation)
      if (this.isSelf) {
        if (this.selfInfo.total === '') {
          this.$L.alert('error', {message: '请配置自助预约相关参数'})
          return
        }
      }
      try {
        this.reservation.reservationTips = this.reservationTips
        if (this.isSelf) {
          this.reservation.extend = this.dealSelfInfo()
          console.log(this.reservation.extend)
        }
        let res = await this.$store.dispatch('personReservation/submitReservation', {
          reservationGroup: this.reservation,
          type: this.type,
        })
        this.$L.alert('success', {message: (status === 'addVehicle') ? '添加成功' : '预约成功'})
        console.log(this.$route.fullPath)
        await this.$L.tab.close(this.$L.tab.current, false)
        if (this.status === 'addVehicle') {
          this.$router.push({
            name: 'PersonReservationGroupDetails',
            params: {id: this.reservation.id},
          })
        }
        else {
          let map = {
            [Reservation.ADMIN]: 'PersonReservationGroupList',
            [Reservation.ORG]: 'PersonOrgReservation',
            [Reservation.PERSONAL]: 'PersonPersonalReservation',
          }
          if (map[this.type]) {
            this.$router.push({
              name: map[this.type],
              params: {refresh: true},
            })
          }
          else {
            this.$router.push('/')
          }
        }
      }
      catch (e) {
        console.log(e)
        this.$L.alert('error', {title: '预约时发生错误', message: e.message, raw: e})
      }
      finally {
        this.submitLoading = false
      }
    },
    dealSelfInfo () {
      let extend = {
        'qrcodePath': '',
        'total': this.selfInfo.total,
        'selfCheckStTime': time.toTimeStamp(this.selfInfo.stTime).toString(),
        'selfCheckEdTime': time.toTimeStamp(this.selfInfo.edTime).toString(),
        'qrcodeUrl': '',
        'isLock': this.selfInfo.isLock,
        'sectionLimit': this.selfInfo.sectionLimit,
        'timeSections': {
        }
      }
      for (let i = 0; i < this.selfInfo.timeSections.length; i++) {
        let t = this.selfInfo.timeSections[i]
        let key = ''
        key += time.toTimeStamp(t.stTime).toString() + ',' + time.toTimeStamp(t.edTime).toString()
        extend['timeSections'][key] = {
          'limit': t.limit,
          'passruleStr': JSON.stringify(t.passRule[0].toAPI())
        }
      }
      return extend
    },
    async deleteVehicles (v, flag = true) {
      if (!v || !flag) {
        return
      }
      if (v instanceof Object) {
        let array = v instanceof Array ? v : [v]
        let {res, close} = await this.$L.confirm({
          title: '确认删除',
          text: '确认删除选中行人？',
          subText: array.map(a => a.plate),
        })
        if (!res) {
          close()
          return
        }
        if (v instanceof Array) {
          let d = []
          this.reservation.vehicles.forEach((t, i) => {
            if (v.find(v_ => v_.ownerTel === t.ownerTel)) {
              d.push(i)
            }
          })
          console.log(v)
          d.sort((a, b) => a - b)
          for (let i = d.length - 1; i >= 0; --i) {
            this.reservation.vehicles.splice(d[i], 1)
            this.vehicleList.splice(d[i], 1)
          }
          this.selected = []
        }
        else if (v instanceof Object && v.plate) {
          let t = this.reservation.vehicles.find(v_ => v_.plate === v.plate)
          if (t) {
            let i = this.reservation.vehicles.indexOf(t)
            this.reservation.vehicles.splice(i, 1)
          }
        }
        close()
      }
      // console.log('delete vehicle success', this.selected)
    },
    hasSameVal () {
      let arr = this.reservation.vehicles.filter(t =>
        (t.ownerTel && t.ownerTel === this.addVehicleForm.ownerTel) ||
        (t.ownerIDNumber && t.ownerIDNumber === this.addVehicleForm.ownerIDNumber)
      )
      console.log(arr)
      return arr.length !== 0
    },
    addVehicle (flag = true) {
      if (!flag) {
        this.addVehicleForm = new VisitorVehicle()
        this.isAddingVehicle = false
        return
      }
      if (this.$refs.addVehicleForm.validate()) {
        if (this.hasSameVal()) {
          this.$L.alert('error', {message: '添加行人有关信息已在已添加列表中存在，请检查修改后添加'})
          return
        }
        let f = this.addVehicleForm
        f.plate = f.ownerTel
        this.vehicleList.push(new VisitorVehicle(
          this.vehicleList.length,
          f.plate,
          f.ownerTel,
          f.ownerName,
          f.ownerOrg,
          f.ownerIDType,
          f.ownerIDNumber,
        ))
        // this.$nextTick(() => {
        this.reservation.vehicles.push(new VisitorVehicle(
          this.reservation.vehicles.length,
          f.plate,
          f.ownerTel,
          f.ownerName,
          f.ownerOrg,
          f.ownerIDType,
          '',
        ))
        if (f.ownerIDNumber !== '') {
          f.plate = f.ownerIDNumber
          this.vehicleList.push(new VisitorVehicle(
            this.reservation.vehicles.length,
            f.plate,
            f.ownerTel,
            f.ownerName,
            f.ownerOrg,
            f.ownerIDType,
            f.ownerIDNumber,
          ))
          f.ownerIDNumber = ''
          this.reservation.vehicles.push(new VisitorVehicle(
            this.reservation.vehicles.length,
            f.plate,
            f.ownerTel,
            f.ownerName,
            f.ownerOrg,
            f.ownerIDType,
            f.ownerIDNumber,
          ))
        }
        // })
        this.addVehicleForm = new VisitorVehicle()
        this.isAddingVehicle = false
      }
    },
    goBack () {
      window.history.length > 1
        ? this.$router.go(-1)
        : this.$router.push('/')
    },
    go (path) {
      if (path) {
        this.$router.push(path)
      }
    },
    async getReservationInfo () {
      let {items} = await this.$store.dispatch('personReservation/getReservationGroups', {
        pagination: {},
        search: {key: 'id', value: this.id}
      })
      if (items.length) {
        let item = items[0]
        this.$emit('updateReservation', item)
      }
      else {
        this.$L.alert('error', '未找到该高级预约')
      }
    },
    getReservationConfig () {
      switch (this.type) {
        case 'org':return this.getReservationConfig_org()
        case 'admin':return this.getReservationConfig_person()
        case 'person':return this.getReservationConfig_person()
      }
    },
    async getReservationConfig_org () {
      let res = await this.$store.dispatch('personReservationConfig/getReservationConfig', 'order_group')
      // console.log(res.data.data)
      if (res.data.status === 1) {
        let object = new ReservationAuthority({
          name: '单位预约',
          maxVehicleAmount: 1000,
          maxStartDay: res.data.data.maxAdvDays,
          maxDurationDay: res.data.data.maxDurDays,
          presetCtrls: res.data.data.presetCtrls,
          limitAreaConfigs: res.data.data.limitAreaConfigs || []
        })
        // console.log(object)
        this.$store.commit('personReservation/setOrgAuth', object)
      }
      else {
        this.$L.alert('error', {message: '查询预约配置失败，原因：' + res.data.msg})
      }
    },
    async getReservationConfig_admin () {
      let res = await this.$store.dispatch('personReservationConfig/getReservationConfig', 'admin')
      console.log(res.data.data)
      if (res.data.status === 1) {
        let object = new ReservationAuthority({
          name: '高级预约',
          maxVehicleAmount: 1000,
          maxStartDay: -1,
          maxDurationDay: res.data.data.maxDurDays,
          presetCtrls: res.data.data.presetCtrls,
          type: ['sectional', 'day', 'week'],

          // 是否可以定义分组名称和描述
          editGroupInfo: true,

          // 是否可定义特殊进出场提示
          editPrompt: true
        })
        // console.log(object)
        this.$store.commit('personReservation/setAdminAuth', object)
      }
      else {
        this.$L.alert('error', {message: '查询预约配置失败，原因：' + res.data.msg})
      }
    },
    async getReservationConfig_person () {
      let res = await this.$store.dispatch('personReservationConfig/getReservationConfig', 'order_object')
      console.log(res.data.data)
      if (res.data.status === 1) {
        let object = new ReservationAuthority({
          name: '个人预约',
          maxVehicleAmount: 1000,
          maxStartDay: res.data.data.maxAdvDays,
          maxDurationDay: res.data.data.maxDurDays,
          presetCtrls: res.data.data.presetCtrls,
          limitAreaConfigs: res.data.data.limitAreaConfigs || []
        })
        // console.log(object)
        this.$store.commit('personReservation/setPersonalAuth', object)
      }
      else {
        this.$L.alert('error', {message: '查询预约配置失败，原因：' + res.data.msg})
      }
    },
  },
  async created () {
    if (this.type === 'person') {
      this.selfInfo.isLock = '1'
      this.selfInfo.total = 2
    }
    if (this.isNew) {
      if (this.type === 'org') {
        this.confirmDialog.activated = true
        this.confirmDialog.msg = msg
        this.confirmDialog.title = title
      }
      this.reservation.applicant = this.self
      this.reservation.owner = this.self
      let config = this.$store.state.reservation.globalConfig || {}
      this.reservation.audioPromptIn = config.audioPromptIn || ''
      this.reservation.ledPromptIn = config.ledPromptIn || ''
      this.reservation.audioPromptOut = config.audioPromptOut || ''
      this.reservation.ledPromptOut = config.ledPromptOut || ''
    }
    if (this.status === 'addVehicle') {
      this.getReservationInfo()
    }
    console.log('inDetails', this.reservation)
  },

}
</script>

<style scoped>

</style>
